module.exports = __webpack_public_path__ + "assets/img/al4.1b9700d4.jpg";